// Utils
import { isObject } from 'ezyvet-fe-helpers';
import { resolveNestedObjectsToObjectIdsForObject } from './resolveNestedObjectsToObjectIdsForObject';
import { resolveObjectOrNestedObjectsToObjectIds } from './resolveObjectOrNestedObjectsToObjectIds';
/**
 * Encodes the nested objects of the given value such that objects are converted to encoded object
 * id references.
 *
 * @see encodeObject
 *
 * @param {any} values
 *
 * @return {any}
 */
export var resolveNestedObjectsToObjectIds = function (values) {
    if (isObject(values)) {
        return resolveNestedObjectsToObjectIdsForObject(values);
    }
    return resolveObjectOrNestedObjectsToObjectIds(values);
};
//# sourceMappingURL=resolveNestedObjectsToObjectIds.js.map